import React, { PureComponent, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Immutable from 'immutable';

import { selectAirlineSeat } from 'actions/bookActions';
import SeatListRow from 'components/AirlineSeatSelection/SeatListRow';
import { flightSeatAttributes } from 'constants/flightSeats';

import SeatListRowHeader from 'components/AirlineSeatSelection/SeatListRowHeader';
import SeatListRowPriceHeader from 'components/AirlineSeatSelection/SeatListRowPriceHeader';
import { fireEvent } from 'utils/optimizely';

import './SeatList.scss';

const mapStateToProps = (state, ownProps) => ({
  flight: state.bookState.getIn(['data', 'flight', ownProps.direction]),
  seatPassengers: state.bookState.getIn(['booking_info', 'airlineSeatPassenger'], Immutable.List()),
  selectedSeats: state.bookState.getIn(['booking_info', 'selection', 'flight_seats', ownProps.direction], Immutable.Map()),
  isMobileBreakpoint: state.appState.get('isMobileBreakpoint'),
});

const mapDispatchToProps = dispatch => ({
  selectSeat: bindActionCreators(selectAirlineSeat, dispatch),
});

export class SeatList extends PureComponent {
  static propTypes = {
    direction: PropTypes.string.isRequired,
    flight: ImmutablePropTypes.map.isRequired,
    seatPassengers: ImmutablePropTypes.listOf(ImmutablePropTypes.mapContains({
      id: PropTypes.number.isRequired,
      counter: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
      paxType: PropTypes.string.isRequired,
    })).isRequired,
    currentPassengerIndex: PropTypes.number.isRequired,
    selectSeat: PropTypes.func.isRequired,
    selectedSeats: ImmutablePropTypes.map.isRequired,
    onSeatSelected: PropTypes.func.isRequired,
    isMobileBreakpoint: PropTypes.bool.isRequired,
  };

  state = {
    hoveredSeat: {},
  };

  getSeatPassenger() {
    const { seatPassengers, currentPassengerIndex } = this.props;
    return seatPassengers.get(currentPassengerIndex);
  }

  handleSeatClick = (rowNumber, seatNumber) => {
    fireEvent('BookSeatSelectionSeat', 'clicked');
    const { selectSeat, direction, onSeatSelected, selectedSeats } = this.props;
    const passengerId = this.getSeatPassenger().get('id');

    const currentSeatForPassenger = selectedSeats.get(`${passengerId}`, Immutable.Map());

    if (currentSeatForPassenger.get('row') === rowNumber && currentSeatForPassenger.get('seat') === seatNumber) {
      selectSeat(direction, passengerId);
    } else {
      selectSeat(direction, passengerId, rowNumber, seatNumber);
      onSeatSelected();
    }
  };

  getRowRepresentation(flightRow) {
    const representation = [];
    let lastRepresentation = null;

    flightRow.get('flightSeats').forEach((flightSeat) => {
      const seatAttributes = flightSeat.get('flightSeatAttributes') || Immutable.List();
      const isNotASeat = seatAttributes.includes(flightSeatAttributes.ABSENT_SEAT) || seatAttributes.includes(flightSeatAttributes.AISLE);

      if (isNotASeat) {
        lastRepresentation = {
          isSeat: false,
          count: 1,
        };
        representation.push(lastRepresentation);
      } else {
        const price = flightSeat.getIn(['flightSeatPrice', 'webPrice']);
        if (lastRepresentation === null || lastRepresentation.price !== price) {
          lastRepresentation = {
            isSeat: true,
            count: 1,
            price,
          };
          representation.push(lastRepresentation);
        } else {
          lastRepresentation.count++;
        }
      }
    });

    return representation;
  }

  areRowRepresentationsIdentical(repA, repB) {
    if (repA.length !== repB.length) {
      return false;
    }

    return repA.every((itemA, index) => {
      const itemB = repB[index];
      if (itemA.isSeat !== itemB.isSeat) {
        return false;
      }

      return itemA.price === itemB.price && itemA.count === itemB.count;
    });
  }

  getStyles() {
    const { flight, isMobileBreakpoint } = this.props;

    const MAX_SEAT_WIDTH = 56;
    const styles = {};
    if (!isMobileBreakpoint) {
      styles.maxWidth = flight.getIn(['flightSeatMap', 'flightRows', '0', 'flightSeats']).size * MAX_SEAT_WIDTH;
    }

    return styles;
  }

  onSeatHover = (rowNumber, seatNumber, hovered) => {
    if (hovered) {
      this.setState({
        hoveredSeat: {
          rowNumber,
          seatNumber,
        },
      });
    } else {
      this.setState({
        hoveredSeat: {},
      });
    }
  };

  render() {
    const { flight, direction } = this.props;
    const { hoveredSeat } = this.state;
    const seatPassenger = this.getSeatPassenger();
    let lastRowRepresentation = null;

    return (
      <div className="seat-list" style={this.getStyles()}>
        <div className="seat-list__rows">
          <SeatListRowHeader flightRow={flight.getIn(['flightSeatMap', 'flightRows', '0'])} />
          {
            flight.getIn(['flightSeatMap', 'flightRows']).map((flightRow) => {
              const currentRowRepresentation = this.getRowRepresentation(flightRow);
              const rowHoveredSeat = hoveredSeat.rowNumber === flightRow.get('rowNumber') ? hoveredSeat.seatNumber : undefined;
              let seatListRowPriceHeader;

              if (lastRowRepresentation === null || !this.areRowRepresentationsIdentical(currentRowRepresentation, lastRowRepresentation)) {
                lastRowRepresentation = currentRowRepresentation;
                seatListRowPriceHeader = (
                  <SeatListRowPriceHeader
                    rowRepresentation={currentRowRepresentation}
                    rowWidth={flightRow.get('flightSeats').size}
                  />
                );
              }

              return (
                <div key={flightRow.get('rowNumber')}>
                  { seatListRowPriceHeader }
                  <SeatListRow
                    direction={direction}
                    flightRow={flightRow}
                    onSeatClicked={this.handleSeatClick}
                    paxType={seatPassenger.get('paxType')}
                    onHover={this.onSeatHover}
                    hoveredSeat={rowHoveredSeat}
                  />
                </div>
              );
            })
          }
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SeatList);



/** WEBPACK FOOTER **
 ** ./src/components/AirlineSeatSelection/SeatList.jsx
 **/